var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fuluid" }, [
    _vm.isMessage
      ? _c(
          "div",
          {
            staticClass: "alert alert-danger alert-margin",
            attrs: { role: "alert" },
          },
          [_vm._v(" " + _vm._s(_vm.message) + " ")]
        )
      : _vm._e(),
    _c("div", { staticClass: "row", attrs: { id: "title" } }, [
      _c("div", { staticClass: "col-1" }, [
        _c(
          "svg",
          {
            staticClass: "bd-placeholder-img mr-2 rounded",
            attrs: {
              id: "header",
              width: "28",
              height: "28",
              xmlns: "http://www.w3.org/2000/svg",
              preserveAspectRatio: "xMidYMid slice",
              focusable: "false",
              role: "img",
              "aria-label": "Placeholder: 32x32",
            },
          },
          [
            _c("rect", {
              attrs: { width: "100%", height: "100%", fill: "#00C3E0" },
            }),
          ]
        ),
      ]),
      _vm._m(0),
    ]),
    _c("div", { staticClass: "row", attrs: { id: "main" } }, [
      _c("div", { staticClass: "col-1" }),
      _c("div", { staticClass: "col-4" }, [
        _c(
          "table",
          {
            staticClass:
              "table table-sm table-hover form-table table-striped table-bordered",
          },
          [
            _vm._m(1),
            _c(
              "tbody",
              _vm._l(_vm.targetNumbers, function (targetNumber, index) {
                return _c("tr", { key: index }, [
                  _c("td", [
                    _c(
                      "button",
                      {
                        staticClass: "btn-sm",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.remove(index)
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "times-solid",
                          attrs: { src: "/times-solid.svg" },
                        }),
                      ]
                    ),
                  ]),
                  _c("td", [_vm._v(_vm._s(targetNumber))]),
                ])
              }),
              0
            ),
          ]
        ),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-8" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.targetNumber,
                  expression: "targetNumber",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                maxlength: "32",
                autocomplete: "off",
                placeholder: "targetNumber",
              },
              domProps: { value: _vm.targetNumber },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.targetNumber = $event.target.value
                },
              },
            }),
          ]),
          _c("div", { staticClass: "col-4" }, [
            _c(
              "button",
              {
                staticClass: "btn-sm btn-outline-info",
                attrs: { type: "submit" },
                on: {
                  click: function ($event) {
                    return _vm.add()
                  },
                },
              },
              [_vm._v("追加する")]
            ),
          ]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-1" }),
      _c("div", { staticClass: "col-4" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-info btn btn-block",
            attrs: { id: "register_button" },
            on: {
              click: function ($event) {
                return _vm.register()
              },
            },
          },
          [_vm._v("更新する")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-7" }, [
      _c("h5", [_vm._v("displayName参照設定一覧")]),
      _vm._v(
        " 電話の名前解決・着信履歴登録時のtargetNumberが以下の番号のときに、displayNameを参照して処理します "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticStyle: { width: "80px" }, attrs: { scope: "col" } }),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("targetNumber")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }